import { useState } from 'react';
import AccountTab from './account';
import NotificationsTab from './notifications';
import MembershipTab from './membership';
import PrivacyTab from './privacy-data';

export default function Settings() {
  const [activeTab, setActiveTab] = useState('account');

  const tabs = [
    { name: 'Account', href: '#', component: AccountTab },
    { name: 'Notifications', href: '#', component: NotificationsTab },
    { name: 'Membership', href: '#', component: MembershipTab },
    { name: 'Privacy & Account', href: '#', component: PrivacyTab },
  ];

  return (
    <main>
      <h1 className='sr-only'>Account Settings</h1>
      <header className='border-b border-gray-200'>
        {/* Secondary navigation */}
        <nav className='flex overflow-x-auto py-4'>
          <ul
            role='list'
            className='flex min-w-full flex-none gap-x-6 px-4 text-sm font-semibold leading-6 text-gray-600 sm:px-6 lg:px-8'
          >
            {tabs.map((tab) => (
              <li key={tab.name}>
                <a
                  href={tab.href}
                  className={activeTab === tab.name.toLowerCase() ? 'text-indigo-600' : ''}
                  onClick={() => setActiveTab(tab.name.toLowerCase())}
                >
                  {tab.name}
                </a>
              </li>
            ))}
          </ul>
        </nav>
      </header>

      {/* Settings forms */}
      <div className='divide-y divide-gray-200'>
        {tabs.map((tab) => (
          <div key={tab.name} className={activeTab === tab.name.toLowerCase() ? '' : 'hidden'}>
            <tab.component />
          </div>
        ))}
      </div>
    </main>
  );
}